// Novo

import axios from "axios";

const url = "https://api.egroup.net.br";

const axiosInstance = axios.create({
  baseURL: url + "/api/v1/",
});

axiosInstance.interceptors.request.use((config) => {
  const token = window.localStorage.token;

  if (token) {
    // SE já tem "Bearer " no início, remove para não duplicar
    const cleanToken = token.replace(/^Bearer\s+/i, "");
    config.headers.Authorization = `Bearer ${cleanToken}`;
  }

  return config;
});

export const api = {
  get(endpoint) {
    return axiosInstance.get(endpoint);
  },
  post(endpoint, body, config = {}) {
    return axiosInstance.post(endpoint, body, config);
  },
  put(endpoint, body) {
    return axiosInstance.put(endpoint, body);
  },
  delete(endpoint) {
    return axiosInstance.delete(endpoint);
  },
  login(body) {
    return axios.post(url + "/api/token", body);
  },
  validateToken() {
    return axiosInstance.post(url + "/api/token/validate");
  },
};

export function formatarData(data) {
  if (!data) return "";

  const d = new Date(data);
  if (isNaN(d)) return data;

  const dia = String(d.getDate()).padStart(2, "0");
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const ano = d.getFullYear();

  const horas = String(d.getHours()).padStart(2, "0");
  const minutos = String(d.getMinutes()).padStart(2, "0");

  return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
}

export const urlImg = "https://api.egroup.net.br/uploads/";
